<template>
  <wizard-form v-bind="ouiaProps" :hidden="hidden" :title="$t('Nome a dominio')">
    <template v-if="!wizard.searchedDomain || !wizard.tldRegistrabile(wizard.searchedDomain)">
      <wizard-question :title="$t('Qual è il nome a dominio, o sottodominio, del progetto?')" style="max-width: 500px">
        <template #description v-if="wizard.path !== 'dominio'">
          {{ $t("Se il dominio non è ancora definitivo indicalo comunque. Ci servirà come nome provvisorio del progetto nell'offerta") }}
        </template>
        <wizard-question-nome-dominio v-model="wizard.nomeDominio" name="nome_dominio" :show-prezzo="wizard.path === 'dominio'" required />

        <pf-alert
          variant="info"
          v-if="wizard.nomeDominio && !wizard.dominioRegistrabile && !wizard.sottodominio"
          :title="$t('L\'estensione del dominio non è fra quelle disponibili per la registrazione.')"
          class="pf-v6-u-mt-sm"
        >
          <template v-if="wizard.path != 'dominio'">
            {{ $t("Puoi procedere comunque con l'offerta, potremo gestire questo aspetto in un secondo momento.") }}
            <i18n-t keypath="Puoi richiedere maggiori informazioni sulle estensioni disponibili {0}." tag="span">
              <router-link :to="{ name: 'tickets' }">
                {{ $t('aprendo un ticket') }}
              </router-link>
            </i18n-t>
          </template>
        </pf-alert>
      </wizard-question>

      <wizard-question-yesno
        v-if="wizard.path !== 'dominio' && wizard.nomeDominio && wizard.dominioRegistrabile"
        :title="$t('Vuoi registrare o trasferire il dominio?')"
        v-model="wizard.attivaDominio"
        name="attiva_dominio"
        required
      >
        <template #label-yes>
          {{ $t('Sì, vorrei registrare/trasferire il dominio e attivare i DNS') }}
          <wizard-price-tag :product="wizard.getProdotto(wizard.codiceProdottoDominio)" />
        </template>
        <template #label-no>
          {{ $t('No, voglio gestire il dominio e i DNS in autonomia') }}
          <wizard-price-tag />
        </template>
      </wizard-question-yesno>
    </template>

    <wizard-searched-domain-info v-else-if="wizard.searchedDomain && wizard.availableDomain !== null" />

    <wizard-question v-if="wizard.domainRegistrationRequired" :title="$t('Vuoi attivare la Registrazione Premium?')">
      <template #description>{{
        $t(
          'La registrazione premium è un servizio unico nel suo genere: tramite l’attivazione di questo speciale contratto premium sarà possibile delegare a noi qualsiasi aspetto della vostra registrazione: tecnico, legale, notarile e amministrativo.',
        )
      }}</template>
      <wizard-question-prodotto
        v-model="wizard.registrazionePremium"
        :product="wizard.getProdotto(wizard.codiciProdottiAddon.registrazionePremium)"
        show-prezzo
      />
    </wizard-question>
  </wizard-form>
</template>

<script lang="ts" setup>
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { useWizardStep } from '@/wizard';

import WizardQuestion from '../questions/wizard-question.vue';
import WizardQuestionYesno from '../questions/wizard-question-yesno.vue';
import WizardQuestionNomeDominio from '../questions/wizard-question-nome-dominio.vue';

import wizardPriceTag from '../wizard-price-tag.vue';
import WizardQuestionProdotto from '../questions/wizard-question-prodotto.vue';
import WizardForm from '../wizard-form.vue';
import wizardSearchedDomainInfo from '../wizard-searched-domain-info.vue';

defineOptions({
  name: 'WizardStepDominio',
});

const props = defineProps<OUIAProps>();
const ouiaProps = useOUIAProps(props);

const { wizard, hidden, isEnabled } = useWizardStep({
  isEnabled: wizard => wizard.askDomainFirst,
});

defineExpose({
  isEnabled,
});
</script>
